<template>
  <div class="d-flex align-center">
    <ClosdFildersIcon :document="file" class="mr-1" style="min-width: 0px" />
    <AppTooltip>
      <template #activator="{ props }">
        <span v-bind="props" class="text-bold text-grey-900 text-truncated mr-5">
          <span v-if="file.numbering" class="mr-1">{{ file.numbering }}</span>
          <span>{{ file.name }}</span>
        </span>
      </template>
      <span>
        <template v-if="file.numbering">{{ file.numbering }}</template>
        {{ file.name }}
      </span>
    </AppTooltip>
    <app-badge v-if="file.version > 1" class="mr-1">{{ `v${file.version}` }}</app-badge>

    <v-spacer />

    <template v-if="isRedactMode">
      <app-button
        type="outlined"
        variant="neutral"
        @click="$emit('close')"
      >
        {{ $t('common.cancel') }}
      </app-button>
      <app-button
        class="ml-4"
        type="primary"
        :disabled="!canRedactDocument"
        @click="openRedactDocumentDialog"
      >
        {{ $t('common.register') }}
      </app-button>
    </template>
    <AppDownloadFile v-else-if="file.id && !file.displayWatermarked" :link="fileLink">
      <template #default="{ submitForm }">
        <app-button
          v-if="$vuetify.display.mdAndUp"
          type="primary"
          class="ml-5"
          :disabled="file?.canDownload === false"
          data-locator="download-button"
          @click="submitForm"
        >
          {{ $t('common.DocumentViewer.downloadLabel') }}
        </app-button>
        <!-- The width of this button should match its height -->
        <app-button
          v-else
          style="width: 40px;"
          type="primary"
          data-locator="download-button"
          @click="submitForm"
        >
          <app-icon-ds icon="arrow-down-to-line" />
        </app-button>
      </template>
    </AppDownloadFile>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'

  import AppDownloadFile from '@/common/AppDownloadFile.vue'
  import AppTooltip from '@/common/AppTooltip.vue'
  import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
  import { roomFileDownloadUrl } from '@/common/utils/files'
  import { DocumentViewerMutationTypes } from '@/store/modules/document-viewer/mutation_types'

  export default {
    name: 'DocumentViewerHeader',
    components: {
      AppDownloadFile,
      AppTooltip,
      ClosdFildersIcon,
    },
    props: {
      file: {
        type: Object,
        required: true,
      },
      mnemo: {
        type: String,
        required: true,
      },
      isRedactMode: {
        type: Boolean,
        default: false,
      },
      redactedZones: {
        type: Array,
        required: true,
      },
    },
    computed: {
      fileLink () {
        return roomFileDownloadUrl(this.file.id, this.mnemo)
      },
      canRedactDocument () {
        return this.redactedZones.length
      },
    },
    methods: {
      ...mapMutations('documentViewer', [DocumentViewerMutationTypes.SET_REDACT_DOCUMENT_DIALOG]),
      openRedactDocumentDialog () {
        this.SET_REDACT_DOCUMENT_DIALOG(true)
      },
    },
  }
</script>
